// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__isvU2","rootSmall":"AddTileButton_rootSmall__f55X4"};